module.exports = __webpack_public_path__ + "img/Manu_I_.41514d61.jpg";